(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gae', {
            parent: 'entity',
            url: '/gae?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.gae.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gae/gaes.html',
                    controller: 'GaeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gae');
                    $translatePartialLoader.addPart('fontiFinanziamento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gae-detail', {
            parent: 'entity',
            url: '/gae/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.gae.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gae/gae-detail.html',
                    controller: 'GaeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gae');
                    $translatePartialLoader.addPart('fontiFinanziamento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Gae', function($stateParams, Gae) {
                    return Gae.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gae',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gae-detail.edit', {
            parent: 'gae-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gae/gae-dialog.html',
                    controller: 'GaeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gae', function(Gae) {
                            return Gae.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gae.new', {
            parent: 'gae',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gae/gae-dialog.html',
                    controller: 'GaeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                esercizio: null,
                                visualizza: false,
                                codice: null,
                                descrizione: null,
                                fonteFondi: null,
                                cup: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gae', null, { reload: 'gae' });
                }, function() {
                    $state.go('gae');
                });
            }]
        })
        .state('gae.edit', {
            parent: 'gae',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gae/gae-dialog.html',
                    controller: 'GaeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gae', function(Gae) {
                            return Gae.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gae', null, { reload: 'gae' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gae.delete', {
            parent: 'gae',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gae/gae-delete-dialog.html',
                    controller: 'GaeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Gae', function(Gae) {
                            return Gae.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gae', null, { reload: 'gae' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
